import styled from 'styled-components';
import { ModalShareConfigurationBasketStyled } from '../../ModalShareConfigurationBasketStyled';

export const ModalShareConfigurationBasketStyledOV = styled(ModalShareConfigurationBasketStyled)`
    button {
        max-width: initial;
    }
`;
